import { Component} from '@angular/core';


interface APRMonths {
  value: number;
  apr: number;

}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent{
  title(title: any) {
    throw new Error('Method not implemented.');
  }

  ammount:number;
  deposit:number;
  month:number;
  rate:any;

  aprmonths: APRMonths[] = [
    {value: 120, apr: 11.9},
    {value: 84, apr: 11.9},
    {value: 60, apr: 11.9},
    {value: 48, apr: 11.9},
    {value: 36, apr: 9.9},
    // {value: 24, apr: 4.9},
    // {value: 12, apr: 0},

  ];

  get credit_ammount(){
    return Number(this.ammount - this.deposit);
  }

  get deposit_ammount(){
    return Number(this.deposit);
  }

  get monthly_payment(){
    if(this.month == 12){
      this.rate = this.month / 12;
      return (  Number(this.credit_ammount) - Number(this.deposit))/12;
    }else{
      this.rate = (Number(this.aprmonths.find(i => i.value === this.month).apr)/100) / 12;
      return ( ( Number(this.credit_ammount) * this.rate ) * ( Math.pow( this.rate + 1, this.month ) ) / ( Math.pow( this.rate + 1, this.month ) - 1 ) );
    }

  }

  get cost_ammount(){
    return ( Number(this.monthly_payment) * this.month ) - Number(this.credit_ammount);
  }

  get total_ammount(){
    return Number(this.ammount) + Number(this.cost_ammount);
  }

  get percentage(){
    return Number(this.aprmonths.find(i => i.value === this.month).apr);
  }

}
